export default __webpack_public_path__ + "static/media/lawn-mower.c0d5f86c.svg";